if (window.location.pathname.startsWith('/products/'))  {
  const productStickyBar = document.querySelector('.product-sticky-bar')

  window.addEventListener('DOMContentLoaded', () => {
    if (productStickyBar) {
      const variantElement = document.querySelector("[data-block-type='variant-picker']")

      if (variantElement) {
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              productStickyBar.classList.remove('is-visible')
            } else {
              productStickyBar.classList.add('is-visible')
            }
          });
        });

        observer.observe(variantElement);
      }
    }
  })

  window.addEventListener('load', () => {
    productStickyBar.classList.add('is-visible')
  })
}
